import { useQuery } from '@tanstack/react-query';

import { fetchFollowCounts, friendsQueryKeys } from '#modules/user/features/friends/model/friends';

/**
 * Сколько подписчиков человек ещё не видел — сигнал раздела «Друзья».
 *
 * Его показывают два места: пункт «Друзья» в нижней панели телефона и в левом меню десктопа.
 * Запрос у них один (тот же ключ кеша), и правило «что зажигает сигнал» тоже одно. Признак входа
 * передаёт вызывающий: гостю запрос вернулся бы ошибкой «the user is not logged in».
 *
 * 🔴 Считаем НЕПРОСМОТРЕННЫХ, а не неотвеченных, и это не мелочь стиля.
 *
 * Раньше здесь стоял `newFollowers` — «подписался на меня, я в ответ нет». Это состояние, а не
 * новость: погасить его можно было только подпиской в ответ, поэтому точка висела у человека
 * месяцами и переставала что-либо значить. Так уведомления не делают ни в LinkedIn (точка на
 * «My Network»), ни в ВК (там счётчик получают заявки, а подписчики — вовсе нет).
 *
 * Число у ярлыка вкладки «Подписчики» при этом ОСТАЁТСЯ на `newFollowers`: оно подписывает
 * содержимое вкладки, и обнулять его от просмотра значит написать «Подписчики 0» над списком
 * из дюжины человек.
 */
export const useUnseenFollowers = (isAuth: boolean) => {
  const { data: counts } = useQuery({
    queryKey: friendsQueryKeys.counts,
    queryFn: fetchFollowCounts,
    enabled: isAuth,
    staleTime: 60_000,
    retry: false,
  });

  return counts?.unseenFollowers ?? 0;
};
